// Feedback and nudge functions
import { 
  API_BASE, stories, isSignedIn, nudgeDismissed, nudgeTimeoutId, hasGivenFeedback,
  setPendingFeedback, setNudgeDismissed, setNudgeTimeoutId, setHasGivenFeedback
} from './state.js';
import { showToast } from './utils.js';

export async function handleFeedback(storyId, action, event) {
  event.stopPropagation();
  const story = stories.find(s => s.id === storyId);
  if (!story) return;

  const btn = event.currentTarget;

  if (!isSignedIn) {
    setPendingFeedback({ storyId, action, story, button: btn });
    document.getElementById('signin-prompt-modal').classList.add('active');
    return;
  }

  try {
    const response = await fetch(`${API_BASE}/feedback`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ storyId, action, topic: story._meta.topic, sources: story._meta.sources })
    });

    if (!response.ok) throw new Error('Server error');

    markFeedbackGiven();
    showToast(action === 'like' ? 'Got it! Showing more like this.' : 'Got it! Less of this.');

    if (btn) {
      btn.classList.add('active');
      setTimeout(() => btn.classList.remove('active'), 1000);
    }
  } catch (error) {
    console.error('Failed to record feedback:', error);
    showToast('Failed to save feedback', 'error');
  }
}

export function showFeedbackNudge() {
  const nudge = document.getElementById('feedback-nudge');
  if (!nudge) return;

  if (nudgeTimeoutId) {
    clearTimeout(nudgeTimeoutId);
    setNudgeTimeoutId(null);
  }

  nudge.classList.add('show');

  const timeoutId = setTimeout(() => {
    if (nudge) nudge.classList.remove('show');
    setNudgeTimeoutId(null);
  }, 8000);
  setNudgeTimeoutId(timeoutId);
}

export function dismissFeedbackNudge() {
  const nudge = document.getElementById('feedback-nudge');
  if (nudgeTimeoutId) {
    clearTimeout(nudgeTimeoutId);
    setNudgeTimeoutId(null);
  }
  if (nudge) nudge.classList.remove('show');
  setNudgeDismissed(true);
}

export function markFeedbackGiven() {
  setHasGivenFeedback(true);
  const nudge = document.getElementById('feedback-nudge');
  if (nudge && nudge.classList.contains('show')) {
    dismissFeedbackNudge();
  }
}
